"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFTBidBuilder = void 0;
const enums_1 = require("../enums");
const transactions_1 = require("../transactions");
const nft_exchange_builder_1 = require("./nft-exchange-builder");
class NFTBidBuilder extends nft_exchange_builder_1.NFTExchangeTransactionBuilder {
    constructor() {
        super();
        this.data.type = enums_1.NFTTransactionTypes.NFTBid;
        this.data.fee = transactions_1.NFTBidTransaction.staticFee();
        this.data.asset = { nftBid: {} };
    }
    NFTBidAsset(nftBid) {
        if (this.data.asset && this.data.asset.nftBid) {
            this.data.asset.nftBid = {
                ...nftBid,
            };
        }
        return this;
    }
    instance() {
        return this;
    }
}
exports.NFTBidBuilder = NFTBidBuilder;
//# sourceMappingURL=nft-bid.js.map